document.addEventListener('DOMContentLoaded', function () {
  const dataEl = document.getElementById('LjomaJudgemeProduct');
  if (!dataEl) return;

  let productData;
  try {
    productData = JSON.parse(dataEl.textContent);
  } catch (error) {
    return;
  }

  if (!productData.imageUrl) return;

  function applyImageData() {
    const reviewsRoot = document.getElementById('judgeme_product_reviews');
    if (reviewsRoot && !reviewsRoot.getAttribute('data-product-image-url')) {
      reviewsRoot.setAttribute('data-product-image-url', productData.imageUrl);
    }

    document.querySelectorAll('.jdgm-rev-widg, .jm-review-widget').forEach((widget) => {
      if (!widget.getAttribute('data-image-url')) {
        widget.setAttribute('data-image-url', productData.imageUrl);
      }
    });
  }

  function ensureModalImage() {
    const modal = document.querySelector('.jdgm-write-review-modal');
    if (!modal) return;

    const pageHeader = modal.querySelector('.jdgm-write-review-modal__page-header');
    if (!pageHeader) return;

    let container = modal.querySelector('.jdgm-write-review-modal__product-image');
    let img = container?.querySelector('img');

    if (img?.src && img.src.startsWith('http') && img.complete && img.naturalWidth > 0) {
      return;
    }

    if (!container) {
      container = document.createElement('div');
      container.className = 'jdgm-write-review-modal__product-image';
      const title = pageHeader.querySelector('.jdgm-write-review-modal__product-title');
      if (title) {
        pageHeader.insertBefore(container, title);
      } else {
        pageHeader.prepend(container);
      }
    }

    if (!img) {
      img = document.createElement('img');
      container.appendChild(img);
    }

    img.src = productData.imageUrl;
    img.alt = productData.title || '';
    container.hidden = false;
    container.style.removeProperty('display');
  }

  applyImageData();

  const observer = new MutationObserver(function () {
    applyImageData();
    ensureModalImage();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['open', 'class', 'hidden', 'style'],
  });

  document.addEventListener(
    'click',
    function (event) {
      if (event.target.closest('.jdgm-write-rev-link, .jdgm-prev-badge, .jdgm-widget')) {
        applyImageData();
        requestAnimationFrame(ensureModalImage);
        setTimeout(ensureModalImage, 100);
        setTimeout(ensureModalImage, 400);
      }
    },
    true
  );
});
